// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3BhVG","imageUploader":"EGiftCard_imageUploader__2oIX1"};